import type { CSSProperties } from "react";

export type DocKind = "pdf" | "doc" | "xls" | "img" | "folder";

// Brand-colored doc icons. Colors are baked into the SVG fills (not currentColor)
// so they keep their identity in both light and dark modes.
export function DocIcon({ kind, size = 36, style }: { kind: DocKind; size?: number; style?: CSSProperties }) {
  const wrapperStyle: CSSProperties = {
    width: size,
    height: size,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    ...style,
  };

  switch (kind) {
    case "folder":
      return (
        <span aria-hidden style={wrapperStyle}>
          <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M20 8H8C5.8 8 4.02 9.8 4.02 12L4 36C4 38.2 5.8 40 8 40H40C42.2 40 44 38.2 44 36V16C44 13.8 42.2 12 40 12H24L20 8Z"
              fill="#A8C7FA"
            />
          </svg>
        </span>
      );
    case "pdf":
      return (
        <span aria-hidden style={wrapperStyle}>
          <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M33.3334 3.33331H13.3334C11.5 3.33331 10 4.83331 10 6.66665V26.6666C10 28.5 11.5 30 13.3334 30H33.3334C35.1667 30 36.6667 28.5 36.6667 26.6666V6.66665C36.6667 4.83331 35.1667 3.33331 33.3334 3.33331ZM19.1667 15.8333C19.1667 17.2166 18.05 18.3333 16.6667 18.3333H15V21.6666H12.5V11.6666H16.6667C18.05 11.6666 19.1667 12.7833 19.1667 14.1666V15.8333ZM27.5 19.1666C27.5 20.55 26.3834 21.6666 25 21.6666H20.8334V11.6666H25C26.3834 11.6666 27.5 12.7833 27.5 14.1666V19.1666ZM34.1667 14.1666H31.6667V15.8333H34.1667V18.3333H31.6667V21.6666H29.1667V11.6666H34.1667V14.1666ZM15 15.8333H16.6667V14.1666H15V15.8333ZM6.66671 9.99998H3.33337V33.3333C3.33337 35.1666 4.83337 36.6666 6.66671 36.6666H30V33.3333H6.66671V9.99998ZM23.3334 19.1666H25V14.1666H23.3334V19.1666Z"
              fill="#F2B8B5"
            />
          </svg>
        </span>
      );
    case "doc":
      return (
        <span aria-hidden style={wrapperStyle}>
          <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M23.3333 3.33331H9.99996C8.16663 3.33331 6.68329 4.83331 6.68329 6.66665L6.66663 33.3333C6.66663 35.1666 8.14996 36.6666 9.98329 36.6666H30C31.8333 36.6666 33.3333 35.1666 33.3333 33.3333V13.3333L23.3333 3.33331ZM26.6666 30H13.3333V26.6666H26.6666V30ZM26.6666 23.3333H13.3333V20H26.6666V23.3333ZM21.6666 15V5.83331L30.8333 15H21.6666Z"
              fill="#4A8FF7"
            />
          </svg>
        </span>
      );
    case "xls":
      return (
        <span aria-hidden style={wrapperStyle}>
          <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M16.6667 16.7H25V35H16.6667V16.7ZM28.3333 35H33.3333C35.1667 35 36.6667 33.5 36.6667 31.6667V16.6667H28.3333V35ZM33.3333 5H8.33333C6.5 5 5 6.5 5 8.33333V13.3333H36.6667V8.33333C36.6667 6.5 35.1667 5 33.3333 5ZM5 31.6667C5 33.5 6.5 35 8.33333 35H13.3333V16.6667H5V31.6667Z"
              fill="#34A853"
            />
          </svg>
        </span>
      );
    case "img":
    default:
      return (
        <span
          aria-hidden
          style={{
            ...wrapperStyle,
            width: Math.round(size * 0.85),
            height: size,
            background: "#8a6d3a",
            color: "#fff",
            borderRadius: 4,
            fontSize: 9,
            fontWeight: 700,
            letterSpacing: 0.5,
          }}
        >
          IMG
        </span>
      );
  }
}
